import { PostgrestResponse } from '@supabase/supabase-js';
import { IContratos } from '../../../types/tables/IContratos'
import { BaseMultiTenantService } from '../base/BaseMultiTenantService'

/**
 * Serviço para gerenciamento de contratos
 */
export class ContratosService extends BaseMultiTenantService<IContratos> {
  constructor() {
    super('contratos', ['titulo', 'descricao', 'versao'], 'fk_id_organizacao')
  }

  /**
   * Busca contratos ativos
   */
  async getAtivos(organizationId: number): Promise<PostgrestResponse<IContratos[]>> {
    const { data, error } = await this.client
      .from(this.tableName)
      .select('*')
      .eq(this.organizationIdField, organizationId)
      .eq('ativo', true)
      .is('deleted_at', null)
      .order('created_at', { ascending: false })

    if (error) {
      throw new Error(`Erro ao buscar contratos ativos: ${error.message}`)
    }

    return { data: data || [], error } as PostgrestResponse<any[]>
  }

  /**
   * Busca contratos por tipo
   */
  async getByTipo(organizationId: number, tipoId: number): Promise<PostgrestResponse<IContratos[]>> {
    const { data, error } = await this.client
      .from(this.tableName)
      .select('*')
      .eq(this.organizationIdField, organizationId)
      .eq('fk_id_tipo_contrato', tipoId)
      .eq('ativo', true)
      .is('deleted_at', null)
      .order('versao', { ascending: false })

    if (error) {
      throw new Error(`Erro ao buscar contratos por tipo: ${error.message}`)
    }

    return { data: data || [], error } as PostgrestResponse<any[]>
  }

  /**
   * Busca contratos vigentes (dentro do período de validade)
   */
  async getVigentes(organizationId: number): Promise<PostgrestResponse<IContratos[]>> {
    const hoje = new Date().toISOString()
    
    const { data, error } = await this.client
      .from(this.tableName)
      .select('*')
      .eq(this.organizationIdField, organizationId)
      .eq('ativo', true)
      .lte('data_inicio', hoje)
      .or(`data_fim.is.null,data_fim.gte.${hoje}`)
      .is('deleted_at', null)
      .order('created_at', { ascending: false })

    if (error) {
      throw new Error(`Erro ao buscar contratos vigentes: ${error.message}`)
    }

    return { data: data || [], error } as PostgrestResponse<any[]>
  }
}

export const contratosService = new ContratosService()
